module.exports = __webpack_public_path__ + "img/customer2_5.70ee9645.png";